import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const friendLinks = ["直播吧", "游戏日报", "电竞观察", "短视频研究院", "创作者社区"];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-background-800 bg-background-900">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
              <i className="ri-live-line text-lg" />
            </span>
            <span className="font-heading text-lg font-extrabold text-foreground-50">
              主播<span className="text-primary-500">视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
            主播视频是聚合热门主播直播录像与精彩集锦的内容站，涵盖游戏、娱乐、才艺等多元直播内容，
            帮助观众快速回看主播高光时刻，发现值得关注的新声主播。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-weibo-fill", "ri-bilibili-fill", "ri-wechat-fill", "ri-youtube-fill"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-700 text-foreground-400 transition-colors hover:border-primary-500 hover:text-primary-400"
              >
                <i className={`${icon} text-base`} />
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-100">内容分类</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {categories.map((cat) => (
              <li key={cat.key}>
                <Link
                  to={`/category/${cat.key}`}
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                >
                  {cat.name}视频
                </Link>
              </li>
            ))}
            <li>
              <Link to="/search" className="text-sm text-foreground-400 transition-colors hover:text-primary-400">
                全部视频
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-100">友情链接</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {friendLinks.map((name) => (
              <li key={name}>
                <a
                  href="https://readdy.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                >
                  {name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 主播视频 · 内容仅供演示，站内视频与主播信息均为示例数据。</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-400">
              关于我们
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-400">
              使用须知
            </Link>
            <Link to="/about" className="transition-colors hover:text-primary-400">
              版权声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}